import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, featureName } from './loading.state';

const getState = createFeatureSelector<State>(featureName);
export const getZIndex = createSelector(getState, (state) => state.zIndex);
export const getProgress = createSelector(getState, (state) => state.progress);
